import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AssetImportPopup from "./AssetImportPopup";
import AppContext from "../../AppContext";
import Loader from "../Loader";
import moment from "moment/moment";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { formatDate } from "@telerik/kendo-intl";
import { LiveDataQualityStatus } from "../LiveDataQualityCircle";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { Trans, useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import AssetGroupedList from "./AssetListComponents/AssetGroupedList";

const AssetList = ({ cardClicked, onSearch, searchedData, assetType }) => {
  const {
    config,
    assets,
    authCtx,
    setConfig,
    apiLoaded,
    getTimeZoneDateTime,
    superAdminCompany,
    darkMode,
    teams,
  } = useContext(AppContext);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const defaultViewMode = [
    {
      id: "grid",
      name: t("masters.headerTexts.grid"),
      current: true,
      icon: "gridIcon.svg",
    },
    {
      id: "list",
      name: t("masters.headerTexts.list"),
      current: false,
      icon: "listIcon.svg",
    },
  ];

  const [viewModes, setViewModes] = useState(defaultViewMode);

  const onUserConfig = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AssetImportPopup
            setPopup={onClose}
            authCtx={authCtx}
            config={config}
            setConfig={setConfig}
            superAdminCompany={superAdminCompany}
          />
        );
      },
    });
  };

  const onCollapseClick = (team) => {
    setConfig((pre) => ({
      ...pre,
      homeConfiguration: pre.homeConfiguration.map((x) =>
        x.teamId === team.teamId ? { ...x, collapsed: !x.collapsed } : x
      ),
    }));
  };

  function searchAsset(obj, searchTerm) {
    const team = config.homeConfiguration.find(
      (x) => x.assetType.id === obj.assetType.id
    );
    // Search in the top-level name field
    if (obj.name && obj.name.toLowerCase().includes(searchTerm)) {
      return true;
    }

    // Search in parameters array
    if (obj.parameters && obj.parameters.length > 0) {
      for (let parameter of obj.parameters) {
        const configIncludes = team.fields.find(
          (x) => x.fieldId === parameter.id && x.fieldType === "parameter"
        );
        if (configIncludes) {
          // Search in each parameter's name field
          if (
            parameter.name &&
            parameter.name.toLowerCase().includes(searchTerm)
          ) {
            return true;
          }
          if (
            parameter.value &&
            searchTerm &&
            String(parameter.value)
              .toLowerCase()
              .includes(searchTerm.toLowerCase())
          ) {
            return true;
          }
        }
      }
    }

    // Search in properties array
    if (obj.properties && obj.properties.length > 0) {
      for (let property of obj.properties) {
        const configIncludes = team.fields.find(
          (x) => x.fieldId === property.id && x.fieldType === "property"
        );
        if (configIncludes) {
          // Search in each property's key and value fields
          if (
            (property.key && property.key.toLowerCase().includes(searchTerm)) ||
            (property.value &&
              property.value.toLowerCase().includes(searchTerm))
          ) {
            return true;
          }
        }
      }
    }

    return false;
  }

  return (
    <div className="bg-transparent flex flex-col w-full h-full py-2 px-3 overflow-y-auto">
      <div className="flex justify-between items-center mb-2 ">
        {/* <label className="text-gray-300 font-semibold text-sm">
          {config && config.homeConfiguration?.assetType.name}
        </label> */}

        <form>
          <div className="relative flex justify-between gap-2">
            <div>
              <button
                type="button"
                className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none"
              >
                <ReactSVG
                  src="search-icon.svg"
                  className="h-9 flex items-center justify-center"
                  beforeInjection={(svg) => {
                    svg.setAttribute(
                      "style",
                      `stroke: ${darkMode ? "white" : "black"}`
                    );
                  }}
                />
              </button>
              <input
                type="search"
                id="default-search"
                className={`block h-8 pl-10 w-full md:text-sm sm:text-xs text-xxs font-normal bg-inherit focus:outline-none dark:text-white dark:placeholder:text-white text-labels placeholder:text-inputPlaceHolderTxts`}
                placeholder={t("home.assetList.searchText")}
                onChange={onSearch}
                value={searchedData}
                required
              />
            </div>
          </div>
        </form>
        <div className="flex justify-between mr-1 items-center text-xs text-gray-300 font-normal gap-1 px-1 z-10">
          <div className="md:flex hidden">
            <button type="button" onClick={() => onUserConfig()}>
              <ReactSVG
                src="Popupedit-button.svg"
                className="h-9 flex items-center justify-center"
                beforeInjection={(svg) => {
                  svg.setAttribute(
                    "style",
                    `stroke: ${darkMode ? "white" : "black"}`
                  );
                }}
              />
            </button>
          </div>
          <hr className=" border-l mx-2 border-neutral-500 md:h-7 h-5 self-center" />
          {viewModes.map((tm, index) => (
            <button
              type="button"
              className={`md:text-xs text-xxs font-medium text-center transition-all ease-in-out duration-200 w-1/2 border-neutral-600`}
              onClick={() =>
                setViewModes((pre) =>
                  pre.map((x) =>
                    x.id === tm.id
                      ? { ...x, current: true }
                      : { ...x, current: false }
                  )
                )
              }
              // disabled={disabled}
              key={tm.id}
            >
              <div
                className={`${
                  tm.current
                    ? `border-b-4 md:pb-1 dark:border-white border-black`
                    : "my-1"
                } flex md:gap-2 gap-1 justify-center transition-all ease-in w-full`}
              >
                <ReactSVG
                  src={tm.icon}
                  className="md:h-5 h-4 flex items-center justify-center"
                  beforeInjection={(svg) => {
                    svg.setAttribute(
                      "style",
                      `fill: ${darkMode ? "white" : "black"}`
                    );
                  }}
                />

                {/* {tm.name} */}
              </div>
            </button>
          ))}
        </div>
      </div>
      {assets &&
      teams &&
      config?.homeConfiguration &&
      config?.homeConfiguration.length > 0 &&
      teams.length > 0 ? (
        teams.map((c) => (
          <div
            key={c.id}
            className={`bg-lightCards dark:bg-dark-card space-y-3 dark:border-neutral-700 border-neutral-400 border-2 mb-3 transition-all ease-in-out duration-200 md:pt-2 pt-1 md:px-2 px-1 pb-1 h-auto flex-col relative rounded-lg`}
          >
            <div
              className={`flex justify-between items-center rounded-t-lg md:px-5 sm:px-3 px-1 ${
                !c?.collapsed ? "mb-3" : "pb-2"
              }`}
            >
              <div
                className={`dark:text-white text-white font-semibold md:text-base sm:text-sm text-xs`}
              >
                {c?.name}
                <label className="text-neutral-500 md:ml-3 ml-1 md:text-lg sm:text-base text-sm font-medium">
                  |
                  <label className=" bg-zinc-900 text-white md:text-xs sm:text-xxs text-xxxs md:w-24 sm:w-20 w-16 h-6 md:px-5 sm:px-3 px-2 py-1 rounded-lg md:ml-3 sm:ml-2 ml-1">
                    {c
                      ? assets.filter((x) =>
                          c.assetTypes
                            .flatMap((x) => x.assetIds?.split(","))
                            .includes(x.id)
                        ).length
                      : 0}
                    &nbsp; Assets
                  </label>
                </label>
              </div>
              <button
                type="button"
                className="text-white font-medium text-xs md:w-5 md:h-5 sm:w-4 sm:h-4 w-3 h-3"
                onClick={() => onCollapseClick(c)}
              >
                {c && (
                  <ReactSVG
                    src="drop-arrow-icon.svg"
                    className={`${
                      !c?.collapsed ? "rotate-180" : ""
                    } h-full flex items-center justify-center`}
                    beforeInjection={(svg) => {
                      svg.setAttribute(
                        "style",
                        `stroke: ${darkMode ? "white" : "black"}`
                      );
                    }}
                  />
                )}
              </button>
            </div>
            <AssetGroupedList
              assets={assets}
              searchedData={searchedData}
              c={c}
              viewModes={viewModes}
              cardClicked={cardClicked}
              getTimeZoneDateTime={getTimeZoneDateTime}
              t={t}
              searchAsset={searchAsset}
              darkMode={darkMode}
              config={config}
            />
          </div>
        ))
      ) : apiLoaded && assets?.length === 0 ? (
        <div className=" flex gap-2 md:text-xs sm:text-xxs text-xxxs font-medium justify-center text-labels text-center items-center h-full">
          <Trans i18nKey="home.assetList.emptyAssetText">
            {t("home.assetList.emptyAssetText")}
          </Trans>
        </div>
      ) : apiLoaded && !config?.homeConfiguration ? (
        <div className=" flex gap-2 md:text-xs sm:text-xxs text-xxxs font-medium justify-center dark:text-slate-500 text-slate-800 text-center items-center h-full">
          <Trans i18nKey="home.noConfigureText">
            {t("home.noConfigureText")}
          </Trans>
          <img src="EditIcongray.svg" alt="EditIcon" className="h-6" />
        </div>
      ) : (
        <div className=" flex justify-center items-center h-full">
          <Loader />
        </div>
      )}
    </div>
  );
};

export default AssetList;
